import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SettingsCompanyRouter } from '../../../settings/types';

@injectable()
export class SettingsCompanyRouterService implements SettingsCompanyRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToCompanySettings() {
    this.history.push('/settings/company');
  }
}
